// extracted by mini-css-extract-plugin
export default {"header":"payments_header__xHa5O","search":"payments_search__sdib9","filterList":"payments_filterList__dzRo6"};